var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c(
      "section",
      { attrs: { id: "wrapper" } },
      [
        _vm.section == "faq"
          ? [_c("Faq")]
          : _vm.section == "tos"
          ? [_c("DocViewer", { attrs: { "doc-key": "tos" } })]
          : _vm.section == "privacy"
          ? [_c("DocViewer", { attrs: { "doc-key": "privacy" } })]
          : _vm.section == "coupon"
          ? [_c("Coupon")]
          : _vm.section == "download"
          ? [_c("Download")]
          : _vm.section == "bridge"
          ? [_c("Bridge")]
          : _vm.section == "membership"
          ? [_c("Membership")]
          : _vm.section == "stampevent"
          ? [_c("StampEvent")]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }